// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"c3d32490","288":"51a7d26c","356":"eb164540","464":"97ecded0","856":"c40c39d0","952":"810ec2ca"}[chunkId] + ".chunk.js";
};